<template>
	<modal
		:title="title"
        :subtitle="group ? group.reportName : ''"
		:active="active"
		:dismissable="true"
        :loading="loading"
		@dismiss="dismiss"
	>
        <template v-if="ready">

            <modal-body v-if="canDeleteGroup">
                <p>
                    This group will be permanently deleted.
                    Any users belonging to this group will still have access to their other groups.
                </p>
            </modal-body>

            <template v-if="!canDeleteGroup">
                <modal-body>
                    <p>
                        To delete this group, please delete each of these dashboards first:
                    </p>                    

                    <section class="b r">
                        <list>
                            <list-item
                                v-for="dashboard in dashboards"
                                :key="dashboard.dashboardID"
                                :clickable="true"
                                :title="dashboard.dashboardName"
                                primary-icon="dashboard"
                                @click="viewDashboard(dashboard.dashboardID)"
                            />
                        </list>
                    </section>
                </modal-body>
            </template>

        </template>

		<modal-actions>
			<btn v-if="ready && canDeleteGroup" :disabled="!ready" primary @click="onDelete">Delete</btn>
			<btn v-if="ready && canDeleteGroup" link @click="cancel">Cancel</btn>
            <btn v-if="!canDeleteGroup" primary @click="close">Close</btn>
		</modal-actions>
		
	</modal>
</template>


<script>
    import _ from 'lodash';
    import { AsyncMixin, LocalPropsMixin, ModalMixin } from 'pdk/mixins';
    import { notifications } from 'pdk/services';
    import { actions } from 'dashboard-pdk/store';
    import { groups } from '@/services';
    import store from '@/store';


	export default {
		name: 'delete-group-modal',
        mixins: [AsyncMixin, ModalMixin, LocalPropsMixin({
            locationGroupId: {
                type: String
            }
        })],
        data() {
            return {
                group: undefined,
                dashboards: undefined
            };
        },
        computed: {
            ready() {
                return typeof this.group !== 'undefined' && typeof this.dashboards !== 'undefined';
            },
            hasDashboards() {
                if (!this.dashboards) return false;
                return this.dashboards.length > 0;
            },
            canDeleteGroup() {
                return !this.hasDashboards;
            },
            title() {
                if (this.ready && !this.canDeleteGroup) return 'Delete group';
                return 'Delete group?';
            }
        },
        methods: {
            openWith(locationGroupID) {
                this.local.locationGroupId = locationGroupID;

                this.open();
            },
            onOpen() {
                this.getGroup()
                    .then(() => {
                        this.getDashboards();
                    })
                    .catch(() => {
                        this.close();
                        notifications.open({
                            content: 'Group not found'
                        });
                    });
            },
            onClose() {
                this.group = undefined;
                this.dashboards = undefined;
            },

            getGroup() {
                return this.async(groups.getGroup({
                    locationGroupID: this.local.locationGroupId
                })).then((group) => {
                    this.group = group;
                });
            },
            getDashboards() {
                return this.async(groups.getDashboards({
                    locationGroupID: this.local.locationGroupId
                })).then((dashboards) => {
                    this.dashboards = dashboards;
                });
            },
            viewDashboard(dashboardID) {
                this.beginAsync();

                store.dispatch(actions.ACTIVE_DASHBOARD_ID_SET, {
                    dashboardID
                }).then(() => {

                    this.$router.push({
                        name: 'group-dashboards',
                        params: {
                            locationGroupId: this.local.locationGroupId
                        }
                    });
                });
            },
            onDelete() {
                return this.async(groups.deleteGroup({
                    locationGroupID: this.local.locationGroupId
                })).then(() => {
                    this.close();
                    this.$emit('delete', {
                        group: this.group
                    });
                });
			}
		}
	};
</script>
